export default __webpack_public_path__ + "static/media/avatar.3abe6cdf.png";